import { Breadcrumb } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';

interface Breadcrumbs {
  items: Array<{
    active: boolean;
    title: string;
    url?: string;
    state?: unknown;
    icon?: string;
  }>;
}

const AdvancedBreadcrumbs: React.FC<Breadcrumbs> = (props) => {
  const { items } = props;

  return (
    <Breadcrumb>
      {items.map((item) => (
        <Breadcrumb.Item key={item.title}>
          {item.icon}
          <Link
            className={`advanced-breadcrumbs__menu__item__link ${
              item.active
                ? 'advanced-breadcrumbs__menu__item__link--active'
                : ''
            }`}
            to={{
              pathname: item.active && item.url ? item.url : '',
              state: item.state ?? undefined,
            }}
          >
            {item.title}
          </Link>
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default AdvancedBreadcrumbs;
